<template>
    <div class="submission-response-wrapper">
        <x-card>
            <x-card-title>
                <x-layout justify-space-between>
                    <x-flex>
                        <h2>{{ isEditing ? 'Edit' : 'Submission' }} response</h2>
                    </x-flex>

                    <x-flex class="text-xs-right">
                        <x-btn color="tertiary" @click="$emit('closeResponsePanel')">
                            <x-icon class="mr-2">close</x-icon>

                            Hide
                        </x-btn>
                    </x-flex>
                </x-layout>
            </x-card-title>

            <x-card-text>
                <x-form ref="make_offer_form" @submit.prevent="submit" v-model="offerValid">
                    <x-container>
                        <x-layout v-if="isCaptiveReinsurance && !isCaptiveOffer">
                            <x-flex>
                                <data-list class="mb-3" v-model="captiveRetainedDataList" />
                            </x-flex>
                        </x-layout>

                        <x-layout v-if="offer.query != null">
                            <x-flex>
                                <p class="query-comment">Current query/comment: {{ this.offer.query }}</p>
                            </x-flex>
                        </x-layout>

                        <x-layout mb-3>
                            <x-flex>
                                <x-radio-group v-model="response" label="Choose response" row>
                                    <x-radio
                                        v-for="(response, index) in responseTypes"
                                        :key="index"
                                        :label="response.name"
                                        :value="response.value"
                                    />
                                </x-radio-group>
                            </x-flex>
                        </x-layout>

                        <x-layout mb-3>
                            <x-flex>
                                <x-divider color="rgba(255, 255, 255, 0.25)" />
                            </x-flex>
                        </x-layout>

                        <x-layout v-if="showQuery">
                            <x-flex>
                                <x-textarea
                                    outline
                                    name="input-7-4"
                                    label="Query/Comment"
                                    placeholder=" "
                                    v-model="offer.query"
                                    :rules="[v => ruleRequired(v, 'Query')]"
                                />
                            </x-flex>
                        </x-layout>

                        <x-layout v-if="showDeclineReasons">
                            <x-flex>
                                <x-select
                                    v-model="selectedDeclineReason"
                                    :items="declineReasons"
                                    :rules="[v => ruleRequired(v, 'Selected declinature')]"
                                    return-object
                                    item-text="reason"
                                    append-icon="keyboard_arrow_down"
                                />
                            </x-flex>
                        </x-layout>

                        <x-layout v-if="showDeclineReasonText">
                            <x-flex>
                                <x-text-field
                                    v-model="offer.decline_reason"
                                    label="Reason for declining"
                                    placeholder=" "
                                    outline
                                    :rules="[v => ruleRequired(v, 'Decline Reason')]"
                                />
                            </x-flex>
                        </x-layout>

                        <template v-if="showOffer">
                            <x-layout mb-3>
                                <x-flex>
                                    <x-radio-group v-model="offerType" label="Choose offer type" row>
                                        <x-radio
                                            v-for="(type, index) in offerTypes"
                                            :key="index"
                                            :label="type.name"
                                            :value="type.value"
                                        />
                                    </x-radio-group>
                                </x-flex>
                            </x-layout>

                            <x-layout v-if="showRateOffer" mb-3>
                                <x-flex>
                                    <value-percent-split-input
                                        v-model="offer.line_size_percent"
                                        :amount-value.sync="offer.line_size_amount"
                                        :total="requiredInsuredAmount"
                                        :currency-code="submission.currency.code"
                                        amountLabel="Quote amount"
                                        percentageLabel="% Line size"
                                        percentagePlaceholder=" "
                                        required
                                    />
                                </x-flex>

                                <x-flex>
                                    <x-text-field
                                        v-model="offer.price"
                                        suffix="BPS"
                                        :rules="priceRules"
                                        label="Quote price"
                                        class="quote-price"
                                        placeholder=" "
                                        outline
                                        required
                                    />
                                </x-flex>
                            </x-layout>

                            <x-layout v-if="showFlatFeeOffer" mb-3>
                                <x-flex>
                                    <value-percent-split-input
                                        v-model="offer.line_size_percent"
                                        :amount-value.sync="offer.line_size_amount"
                                        :total="requiredInsuredAmount"
                                        :currency-code="submission.currency.code"
                                        amountLabel="Maximum line size"
                                        percentageLabel="% Line size"
                                        percentagePlaceholder=" "
                                        required
                                    />
                                </x-flex>

                                <x-flex>
                                    <x-currency-text-field
                                        v-model="flatFee"
                                        label="Flat fee"
                                        placeholder=" "
                                        class="quote-price"
                                        :prefix="submission.currency.code"
                                        :rules="[
                                        v => ruleRequired(v, 'Flat fee')
                                    ]"
                                        outline
                                        required
                                    />
                                </x-flex>
                            </x-layout>

                            <x-layout v-if="showPercentageOfMarginOffer" mb-3>
                                <x-flex>
                                    <value-percent-split-input
                                        v-model="offer.line_size_percent"
                                        :amount-value.sync="offer.line_size_amount"
                                        :total="requiredInsuredAmount"
                                        :currency-code="submission.currency.code"
                                        amountLabel="Maximum line size"
                                        percentageLabel="% Line size"
                                        percentagePlaceholder=" "
                                        required
                                    />
                                </x-flex>

                      <x-flex v-if="haveMarginFieldDefined">
                          <value-percent-split-input
                            v-model="offer.percentage_of_margin"
                            :amount-value.sync="offer.price"
                            :total="totalMargin"
                            currency-code="BPS"
                            amountLabel="Price"
                            percentageLabel="% of margin"
                            calculatePercentageWithoutLimit
                            percentagePlaceholder=" "
                            required
                        />
                    </x-flex>

                                <template v-if="!haveMarginFieldDefined">
                                    <x-flex>
                                        <x-text-field
                                            v-model="offer.percentage_of_margin"
                                            suffix="%"
                                            label="Percentage of margin"
                                            class="quote-price"
                                            placeholder=" "
                                            :rules="[
                                            v => ruleRequired(v, 'Percentage of margin'),
                                            v => ruleGreaterThan(v, 0, 'Percentage of margin'),
                                        ]"
                                            outline
                                            required
                                        />
                                    </x-flex>

                                    <x-flex v-if="!haveMarginFieldDefined">
                                        <x-text-field
                                            v-model="offer.minimum_price"
                                            suffix="BPS"
                                            label="Minimum price"
                                            class="quote-price"
                                            placeholder=" "
                                            :rules="[
                                            v => ruleRequired(v, 'Minimum price'),
                                            v => ruleGreaterThanOrEqualTo(v, 0, 'Minimum price')
                                        ]"
                                            outline
                                            required
                                        />
                                    </x-flex>
                                </template>
                            </x-layout>

                            <x-layout v-if="showRetainedPercentOffer" mb-3>
                                <x-flex>
                                    <value-percent-split-input
                                        v-model="offer.line_size_percent"
                                        :amount-value.sync="offer.line_size_amount"
                                        :total="requiredInsuredAmount"
                                        :currency-code="submission.currency.code"
                                        amountLabel="Retained amount"
                                        percentageLabel="Retained %"
                                        percentagePlaceholder=" "
                                        required
                                        :allow-zero="true"
                                        :maxAmount="submission.captive_maximum_retained_amount"
                                        :percentage-rules="[
                                        v => ruleLessThanOrEqualTo(v, submission.captive_maximum_retained_percentage, 'Percentage')
                                    ]"
                                    />
                                </x-flex>
                            </x-layout>

                            <template v-if="['rate', 'flat_fee', 'percentage_of_net_margin', 'percentage_of_gross_margin'].includes(offerType)">
                                <x-layout mb-3>
                                    <x-flex>
                                        <x-select
                                            v-model="offer.waiting_period"
                                            :items="filteredWaitingPeriods"
                                            :rules="[v => ruleRequired(v, 'Waiting period')]"
                                            label="Waiting period"
                                            item-text="name"
                                            item-value="value"
                                            append-icon="keyboard_arrow_down"
                                            attach
                                        />
                                    </x-flex>
                                </x-layout>

                                <x-layout v-show="hasSecurities" mb-3>
                                    <x-flex>
                                        <add-edit-securities :offer="offer" :facility-id="submission.facility_id" @hasSecurities="checkSecurities" />
                                    </x-flex>
                                </x-layout>

                                <x-layout mb-3>
                                    <x-flex>
                                        <add-edit-subjectivities v-model="subjectivitiesArray"/>
                                    </x-flex>
                                </x-layout>
                            </template>
                        </template>

                        <x-layout class="submission-response__actions">
                            <x-flex class="text-xs-right">
                                <x-btn
                                    type="submit"
                                    color="primary"
                                    :disabled="!response || !offerValid || loading"
                                    :loading="loading"
                                    @click="validate"
                                >
                                    Submit offer

                                    <x-icon class="ml-2">trending_flat</x-icon>
                                </x-btn>
                            </x-flex>
                        </x-layout>
                    </x-container>
                </x-form>
            </x-card-text>

            <modal
                ref="confirmDecline"
                title="Decline submission"
                confirmation
            >
                <div class="text-xs-left">
                    <p>
                        Are you sure you want to decline this submission?
                    </p>
                    <p>
                        Reason: {{ offer.decline_reason }}
                    </p>
                </div>
            </modal>

            <modal
                ref="confirmQuery"
                title="Query submission"
                confirmation
            >
                <div class="text-xs-left">
                    <p>
                        Confirm you wish to leave the following query/comment:
                    </p>
                    <p>
                        Query/Comment: {{ offer.query }}
                    </p>
                    <p v-if="isEditing">
                        This will remove any previous offer.
                    </p>
                </div>
            </modal>

            <modal
                ref="confirmEdit"
                title="Confirm edit offer"
                confirmation
            >
                <p>Are you sure you would like to update your offer?</p>
            </modal>

        <modal
            ref="confirmOffer"
            title="Confirm offer"
            confirmation
        >
            <div class="text-xs-left">
                <p>
                    Max line: {{ offer.line_size_percent | percent }} ({{ offer.line_size_amount | currency(submission.currency.code) }})
                </p>
                <p v-if="offerType === 'rate'">
                    Price: {{ offer.price | numberNoTrail }} BPS
                </p>
                <p v-if="offerType === 'flat_fee'">
                    Flat fee: {{ flatFee | currency(submission.currency.code) }}
                </p>
                <p v-if="offerType === 'percentage_of_net_margin' && submission.net_margin">
                    Price: {{ (offer.percentage_of_margin / 100) * submission.net_margin | numberNoTrail }} BPS ({{ offer.percentage_of_margin | percent }} of {{ submission.net_margin }} BPS)
                </p>
                <p v-if="offerType === 'percentage_of_net_margin' && !submission.net_margin">
                    Percentage of net margin: {{ offer.percentage_of_margin | percent }}
                </p>
                <p v-if="offerType === 'percentage_of_gross_margin' && submission.gross_margin">
                    Price: {{ (offer.percentage_of_margin / 100) * submission.gross_margin | numberNoTrail }} BPS ({{ offer.percentage_of_margin | percent }} of {{ submission.gross_margin }} BPS)
                </p>
                <p v-if="offerType === 'percentage_of_gross_margin' && !submission.gross_margin">
                    Percentage of gross margin: {{ offer.percentage_of_margin | percent }}
                </p>
                <p v-if="offer.waiting_period">
                    Waiting Period: {{ offer.waiting_period }} days
                </p>
                <br>
                <template v-if="subjectivitiesArray.length > 0">
                    <p>
                        Subjectivities:
                    </p>

                    <p v-for="subjectivity in subjectivitiesArray">
                        - {{ subjectivity }}
                    </p>
                </template>
            </div>
        </modal>
        </x-card>
    </div>
</template>

<script>
    import AddEditSubjectivities from "~/components/Insurer/AddEditSubjectivities";
    import AddEditSecurities from "~/components/Insurer/AddEditSecurities";
    import ValuePercentSplitInput from "~/components/Shared/UIComponents/ValuePercentSplitInput";
    import premium from "~/mixins/premium";
    import rules from '~/mixins/rules';
    import Modal from '~/components/Shared/UIComponents/Modal';
    import DataList from '~/components/Shared/UIComponents/DataList';

    export default {
        name: "SubmissionResponse",
        components: {
            ValuePercentSplitInput,
            AddEditSecurities,
            AddEditSubjectivities,
            Modal,
            DataList
        },
        mixins: [rules],
        props: {
            submission: {
                type: Object,
                default: {}
            },
            value: Object,
            offer: {
                type: Object,
                default: {}
            },
            isEditing: Boolean
        },
        data: function () {
            return {
                waitingPeriods: this.$root.waitingPeriods,
                response: null,
                offerType: null,
                responseTypes: [
                    {
                        value: 'offer',
                        name: 'Offer',
                        order: 77,
                    },
                    {
                        value: 'query',
                        name: 'Query/Comment',
                        order: 88,
                    },
                    {
                        value: 'decline',
                        name: 'Decline',
                        order: 99,
                    },
                ],
                allOfferTypes: [
                    {
                        value: 'rate',
                        name: 'Offer (Rate)',
                        order: 11,
                        applies_to: ['insurer']
                    },
                    {
                        value: 'flat_fee',
                        name: 'Offer (Flat fee)',
                        order: 22,
                        disabled_on_captive: true,
                        applies_to: ['insurer']
                    },
                    {
                        value: 'retained_percent',
                        name: 'Offer (Retained percent)',
                        order: 44,
                        applies_to: ['captive_insurer']
                    },
                ],
                selectedDeclineReason: null,
                offerValid: false,
                priceRules: [
                    value => value !== null || 'Please enter a price',
                    value => value !== '' || 'Please enter a price',
                ],
                loading: false,
                flatFee: '',
                subjectivitiesArray: [],
                declineReasons: [],
                hasSecurities: false
            }
        },
        mounted() {
            if (this.isEditing && this.offer.hasOwnProperty('status')) {
                if (this.offer.status === 'offered') {
                    this.response = 'offer';
                }
                if (this.offer.status === 'declined') {
                    this.response = 'decline';
                }
            }

            if (this.isEditing && this.offer.hasOwnProperty('type')) {
                this.offerType = this.offer.type;
            }

            if (this.isEditing && this.offer.hasOwnProperty('flat_fee')) {
                this.flatFee = this.offer.flat_fee;
            }

            if (this.isEditing && this.offer.hasOwnProperty('subjectivities')) {
                this.subjectivitiesArray = this.offer.subjectivities.map(s => s.name);
            }

            if (!this.isEditing) {
                this.offer.price = null;
            }
        },
        methods: {
            submit: function () {
                switch (this.response) {
                    case 'offer':
                    case 'rate':
                    case 'flat_fee':
                    case 'percentage_of_net_margin':
                    case 'percentage_of_gross_margin':
                    case 'retained_percent':
                        this.makeOffer();
                        break;
                    case 'decline':
                        this.declineOffer();
                        break;
                    case 'query':
                        this.queryOffer();
                        break;
                }
            },
            queryOffer: async function () {
                if (await this.$refs.confirmQuery.open() === false) {
                    return;
                }

                this.loading = true;
                await axios.put(`/api/insurer/submission/${this.submission.id}/offer/${this.offer.id}/query`, {
                    queryString: this.offer.query,
                    offerId: this.offer.id,
                    removeOffer: this.isEditing
                }).catch(() => {
                    this.loading = false;
                });

                this.$eventBus.$emit('insurerSubmissionChanged');
                this.$emit('closeResponsePanel');
            },
            makeOffer: async function () {
                if (this.isEditing && await this.$refs.confirmEdit.open() === false) {
                    return;
                }

                if (!this.isEditing && await this.$refs.confirmOffer.open() === false) {
                    return;
                }


                this.loading = true;
                this.load = false;

                if (!this.$refs.make_offer_form.validate()) {
                    return false;
                }

                this.offer.response_type = this.response !== 'offer' ? this.response : this.offerType;

                if (this.offerType === 'rate') {
                    this.offer.percentage_of_margin = null;
                    this.offer.flat_fee = null;
                    this.offer.minimum_price = null;
                } else if (this.offerType === 'flat_fee') {
                    this.offer.price = null;
                    this.offer.percentage_of_margin = null;
                    this.offer.flat_fee = this.flatFee;
                    this.offer.minimum_price = null;
                } else if (['percentage_of_net_margin', 'percentage_of_gross_margin'].includes(this.offerType)) {
                    this.offer.flat_fee = null;
                }

                const madeOffer = {
                    ...this.offer,
                    subjectivities: this.subjectivitiesArray
                };

                if (this.isEditing) {
                    await axios.put(`/api/insurer/submission/${this.submission.id}/offer/edit`, madeOffer);
                    await this.$router.push(`/insurer/risk/${this.submission.id}`);
                    this.$eventBus.$emit('insurerSubmissionChanged');
                    this.$emit('closeResponsePanel');
                } else {
                    await axios.post(`/api/insurer/submission/${this.submission.id}/offer`, madeOffer);
                    this.$eventBus.$emit('insurerSubmissionChanged');
                    this.$emit('closeResponsePanel');
                }
            },
            declineOffer: async function () {
                if (await this.$refs.confirmDecline.open() === false) {
                    return;
                }

                this.loading = true;

                await axios.put(`/api/insurer/submission/${this.submission.id}/offer/${this.offer.id}/decline`, {
                    decline_reason_id: this.selectedDeclineReason.id,
                    decline_reason: this.offer.decline_reason
                }).catch(() => {
                    this.loading = false;
                });

                this.$eventBus.$emit('insurerSubmissionChanged');
                this.$emit('closeResponsePanel');
            },
            validate() {
                if (!this.$refs.make_offer_form.validate()) {
                    this.loading = false;
                }
            },
            async getDeclineReasons() {
                this.declineReasons = (await axios.get(this.$root.api(`insurer/decline-reasons`))).data.data;
            },
            checkSecurities(value) {
                this.hasSecurities = value
            },
            defaultMinimumPricingFieldToZero() {
                if (this.showPercentageOfMarginOffer && !this.submission.net_margin) {
                    this.offer.minimum_price =  this.offer.minimum_price ?? 0;
                }
            }
        },
        created() {
            this.getDeclineReasons();
        },
        computed: {
            isCaptiveReinsurance() {
                return this.submission.transaction_type === 'captive_reinsurance';
            },
            offerTypes() {
                const {allOfferTypes} = this;

                if (this.submission.product.key !== 'supply_chain_reinsurance') {
                    allOfferTypes.push(
                        {
                            value: 'percentage_of_net_margin',
                            name: 'Offer (Percentage of net margin)',
                            order: 33,
                            applies_to: ['insurer']
                        },
                        {
                            value: 'percentage_of_gross_margin',
                            name: 'Offer (Percentage of gross margin)',
                            order: 34,
                            applies_to: ['insurer']
                        },
                    );
                }

                let filteredOfferTypes = allOfferTypes.filter(type => type.applies_to.includes(this.$root.user.company.company_type));

                if (this.isCaptiveReinsurance) {
                    filteredOfferTypes = filteredOfferTypes.filter(type => !type.disabled_on_captive);
                }

                return filteredOfferTypes.sort(function(a, b) {
                    return a.order - b.order;
                });
            },
            filteredWaitingPeriods() {
                if (Boolean(this.submission.facility) && Boolean(this.submission.facility.waiting_period_values)) {
                    return this.waitingPeriods.filter(wp => this.submission.facility.waiting_period_values.includes(wp.value));
                }

                return this.waitingPeriods.filter(wp => wp.default);
            },
            showDeclineReasons() {
                return this.response === 'decline';
            },
            showQuery() {
                return this.response === 'query';
            },
            showOffer() {
                return this.response === 'offer';
            },
            showRateOffer() {
                return this.offerType === 'rate';
            },
            showFlatFeeOffer() {
                return this.offerType === 'flat_fee';
            },
            showPercentageOfMarginOffer() {
                return ['percentage_of_net_margin', 'percentage_of_gross_margin'].includes(this.offerType);
            },
            haveMarginFieldDefined() {
                return this.submission.net_margin && this.response === 'percentage_of_net_margin' ||
                    (this.submission.gross_margin && this.response === 'percentage_of_gross_margin')
            },
            totalMargin() {
              if (this.response === 'percentage_of_net_margin') {
                  return this.submission.net_margin;
              } else if (this.offerType === 'percentage_of_gross_margin') {
                  return this.submission.gross_margin;
              }
            },
            isCaptiveOffer() {
                return Boolean(this.offer.captive_insurer_company_id);
            },
            showRetainedPercentOffer() {
                return this.offerType === 'retained_percent';
            },
            showDeclineReasonText() {
                return this.response === 'decline'
            },
            captiveRetainedAmount() {
                return (this.submission.retained_percent / 100) * this.submission.contract_value;
            },
            requiredInsuredAmount() {
                if (this.isCaptiveReinsurance) {
                    return this.submission.contract_value;
                }

                return this.submission.limit_of_liability;
            },
            captiveRetainedDataList() {
                return [
                    {
                        text: 'Limit amount',
                        value: this.$options.filters.currency(this.submission.contract_value, this.submission.currency.code)
                    },
                    {
                        text: 'Retained amount',
                        value: this.submission.retained_percent === 0 ? this.$options.filters.percent(this.submission.retained_percent) : '(' + this.$options.filters.percent(this.submission.retained_percent) + ') ' + this.$options.filters.currency(this.captiveRetainedAmount, this.submission.currency.code)
                    },
                    {
                        text: 'Maximum facultative reinsured exposure required',
                        value: this.submission.retained_percent === 0 ? 'Fronting' : this.$options.filters.currency(this.requiredInsuredAmount, this.submission.currency.code)
                    }
                ]
            },
        },
        watch: {
            selectedDeclineReason(declineReason) {
                this.offer.decline_reason_id = declineReason.id
                this.offer.decline_reason = '';
            },
            filteredWaitingPeriods: {
                handler(newValue) {
                    if (newValue.length === 1) {
                        this.offer.waiting_period = newValue[0].value;
                    }
                },
                immediate: true
            },
            response() {
                this.defaultMinimumPricingFieldToZero();
            }
        }
    }
</script>

<style lang="scss" scoped>
$card-background: linear-gradient(90.05deg, rgba(255, 255, 255, 0.15) 37.57%, rgba(255, 255, 255, 0.03) 77.35%) !important;

.submission-response-wrapper {
    position: fixed;
    top: 56px;
    right: 0;
    width: calc(50% - 24px);
    height: calc(100% - 56px);
    z-index: 196;
    line-height: 1;
    border-radius: 24px 0 0 0;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 24px 0 0 0;
        border-top: 1px solid transparent;
        border-left: 1px solid transparent;
        background: linear-gradient(0.08deg, rgba(#fff, 0.04) 0.08%, rgba(#fff, 0.2) 99.94%) border-box;
        -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: destination-out;
        mask-composite: exclude;
    }

    &.show {
        transform: translateX(0);
    }

    .x-card {
        height: 100%;
        position: relative;
        padding: 0;
        border-radius: 24px 0 0 0;
        background: transparent !important;

        .x-card__title {
            padding: 0;
            background: $card-background;
        }

        .x-card__text {
            height: calc(100% - 224px);
            background: $card-background;
            overflow-y: auto;
        }
    }
}

    .theme--dark.x-card {
        .x-card__title {
            padding: 32px 40px;
        }

        .x-card__text {
            padding: 0 24px 40px;
        }
    }

    .query-comment {
        margin-bottom: 20px;
    }

    :deep(.text-field .x-input__control .x-input__slot) {
        background-color: #FFF;
    }

    .form-text-label {
        text-transform: uppercase;
        height: 18px;
        color: #5B6786;
        opacity: .5;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.92px;
        line-height: 15px;
    }

    .nudge-form-text-label {
        margin-top: 15px;
    }

    :deep(.theme--light) {

        &.x-btn.btn-submit {
            border-radius: 4px;
            background-color: #60BF5C;
            box-shadow: none;
            margin: 0;

            .x-btn__content {
                color: #fff;
                font-size: 12px;
                font-weight: 600;
            }
        }

        &.x-btn.btn-back {
            border: none;
            background-color: transparent;
            box-shadow: none;
            margin: 0;

            .x-btn__content {
                color: #D0021B;
                font-size: 12px;
                font-weight: 600;
                text-decoration: underline;
            }
        }
    }

    .x-btn.btn-lookup {
        box-sizing: border-box;
        height: 42px;
        width: 122px;
        border: 2px solid #60BF5C;
        border-radius: 4px;
        box-shadow: 0 4px 8px 0 rgba(29, 30, 44, 0.15), 0 2px 4px 0 rgba(30, 31, 40, 0.1);

        .x-btn__content {
            height: 19px;
            width: 63px;
            color: #60BF5C;
            font-family: inherit;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.44px;
            line-height: 19px;
            text-align: center;
        }
    }

    .submission-response__actions {
        position: absolute;
        bottom: 0;
        left: 8px;
        width: 100%;
        padding: 24px;
        background: rgba(255, 255, 255, 0.1);

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-top: 1px solid transparent;
            background: linear-gradient(0.08deg, rgba(#fff, 0.04) 0.08%, rgba(#fff, 0.2) 99.94%) border-box;
            -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: destination-out;
            mask-composite: exclude;
        }
    }
</style>
